import { Modal } from '@interstate/components/Modal';
import React, { useEffect, useState } from 'react';

interface DealTypeChangeNoticeProps {
    onClose?: () => void;
}

export const DealTypeChangeNotice = ({ onClose }: DealTypeChangeNoticeProps) => {
    const [isModalOpen, setIsModalOpen] = useState(true);

    useEffect(() => {
        setIsModalOpen(true);
    }, []);

    const handleDealTypeNoticeClose = () => {
        setIsModalOpen(false);
        onClose?.();
    };

    return (
        <Modal
            data-testid="deal-type-change-notice-modal-test-id"
            footer={{
                primary: {
                    action: () => handleDealTypeNoticeClose(),
                    label: 'Okay'
                }
            }}
            header="Deal Type Change Notice"
            id="deal-type-change-notice-modal-id"
            onHide={handleDealTypeNoticeClose}
            size="small"
            show={isModalOpen}
        >
            <p>
                Changing the deal type will reset the current ecommerce order when the deal is saved. The buyer will get a new
                checkout link and must complete the process again.
            </p>
        </Modal>
    );
};
